import api from './api';

const APPROVALS_BASE = '/devices/approvals';

/**
 * Device approvals API for auto-provisioning workflow.
 * Backend: GET/POST devices/approvals, devices/approvals/pending, devices/approvals/:deviceSerial/approve|reject|unblock
 */
export const deviceApprovalsService = {
  /**
   * Get pending device approvals (for admin review)
   */
  async getPendingApprovals() {
    const response = await api.get(`${APPROVALS_BASE}/pending`);
    return response.data;
  },

  /**
   * Get all approvals with optional status filter
   * @param {string} [status] - 'pending' | 'approved' | 'rejected' | 'expired'
   */
  async getApprovals(status) {
    const params = status ? { status } : {};
    const response = await api.get(APPROVALS_BASE, { params });
    return response.data;
  },

  /**
   * Approve a device for auto-provisioning
   * @param {string} deviceSerial
   * @param {{ reason?: string, claimToken?: string }} body
   */
  async approveDevice(deviceSerial, body = {}) {
    const response = await api.post(`${APPROVALS_BASE}/${encodeURIComponent(deviceSerial)}/approve`, {
      deviceSerial,
      reason: body.reason,
      claimToken: body.claimToken,
    });
    return response.data;
  },

  /**
   * Reject a device from auto-provisioning
   * @param {string} deviceSerial
   * @param {{ reason?: string }} body
   */
  async rejectDevice(deviceSerial, body = {}) {
    const response = await api.post(`${APPROVALS_BASE}/${encodeURIComponent(deviceSerial)}/reject`, {
      deviceSerial,
      reason: body.reason,
    });
    return response.data;
  },

  /**
   * Unblock a device that exceeded max attempts (resets attempt count)
   * @param {string} deviceSerial
   */
  async unblockDevice(deviceSerial) {
    const response = await api.post(
      `${APPROVALS_BASE}/${encodeURIComponent(deviceSerial)}/unblock`
    );
    return response.data;
  },
};

export default deviceApprovalsService;
